export default function RichTextEditor({ block, position }) {
  const {
    content,
    add_space_below,
    container_size,
    container_padding,
    background_color_picker
  } = block.rich_text_editor;

  // Utility for padding
  const getPaddingClass = (size) => {
    switch (size) {
      case 'Small':
        return 'py-15';
      case 'Medium':
        return 'py-20';
      case 'Large':
      case 'Lage':
        return 'py-30';
      default:
        return 'py-0';
    }
  };

  // Utility for container width
  const getContainerClass = (size) => {
    switch (size) {
      case 'Narrow':
        return 'w-full max-w-[600px]';
      case 'Standard':
        return 'w-full max-w-[800px]';
      case 'Full Page':
        return 'w-full max-w-[1200px]';
      default:
        return 'w-full max-w-[1200px]';
    }
  };

  return (
    <section
      id={`rich_text_editor_${position}`}
      data-name={'rich_text_editor'}
      style={{ backgroundColor: background_color_picker }}
      className={`rich_text_editor ${getPaddingClass(container_padding)}`}
    >
      <div
        className={`${getContainerClass(container_size)} container px-4 sm:px-10 lg:px-20 2xl:px-0`}
      >
        <div
          className={`rte ${add_space_below ? `mb-${add_space_below}` : ''}`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </section>
  );
}
